export enum CodeTab {
    Details = 'details',
    Metrics = 'metrics',
    Logs = 'logs',
    Events = 'events',
    Inspect = 'inspect',
}

export const RUN_DETAILS_REFRESH_LIST_EVENT = 'RUN_DETAILS_REFRESH_LIST_EVENT';
